//@ts-nocheck

const caseAjax = () => {
  const state = document.querySelector(".js-state-wrapper");
  if (!state) {
    return;
  }
  const stateSelect = document.querySelector(".js-state-select");
  const stateItems = document.querySelectorAll(".js-state-item");
  const district = document.querySelector(".js-district-wrapper");
  const districtSelect = document.querySelector(".js-district-select");
  const districtList = document.querySelector(".js-district-list");
  const check = document.querySelector(".js-state-check");
  const submit = document.querySelector(".js-case-submit");

  const postWrapper = document.querySelector(".js-case-posts");

  let districtSlug = "";
  let stateSlug = "";

  const clearDisplay = document.querySelector(".js-filters-clear-display");
  const clearBtn = document.querySelector(".js-filters-clear");
  const clearTitle = document.querySelector(".js-filters-clear-title");

  clearBtn?.addEventListener("click", () => {
    districtSlug = "";
    stateSlug = "";
    clearDisplay?.classList.add("hidden");
    fetchData();
  });

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("js-state-select")) {
      state.classList.toggle("active");
    } else if (e.target.classList.contains("js-state-item")) {
      let text = e.target.querySelector("p").innerText;
      stateSlug = e.target.getAttribute("data-slug");
      let id = e.target.getAttribute("data-id");
      stateSelect.querySelector("p").innerText = text;
      districtSelect.querySelector("p").innerText = "– Select –";
      state.classList.remove("active");
      submit?.classList.add("available");
      populateDistrict(id);
    } else if (e.target.classList.contains("js-district-select")) {
      district?.classList.toggle("active");
    } else if (e.target.classList.contains("js-district-item")) {
      let text = e.target.querySelector("p").innerText;
      districtSelect.querySelector("p").innerText = text;
      districtSlug = e.target.getAttribute("data-slug");
      district.classList.remove("active");
    } else if (e.target.classList.contains("js-state-check")) {
      e.target.classList.toggle("active");
    } else if (e.target.classList.contains("js-case-submit")) {
      if (!e.target.classList.contains("available")) {
        return;
      } else {
        let stateTitle = stateSelect?.querySelector("p")?.innerText;
        let districtTitle = districtSelect?.querySelector("p")?.innerText;
        let formTitle = stateTitle;

        if (districtTitle != "– Select –") {
          formTitle += ", " + districtTitle;
        }
        clearTitle?.innerText = "Applied: " + formTitle;
        clearDisplay?.classList.remove("hidden");
        fetchData();
      }
    }
  });

  async function populateDistrict(id) {
    let formData = new FormData();
    formData.append("action", "populate_districts");
    formData.append("id", id);
    const response = await fetch(window.globals.ajax_url, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    districtList?.innerHTML = data.items;
  }

  async function fetchData() {
    let formData = new FormData();
    formData.append("action", "case_ajax");
    formData.append("state", stateSlug);
    formData.append("district", districtSlug);
    const response = await fetch(window.globals.ajax_url, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    postWrapper.innerHTML = data.files;
  }
};

export default caseAjax;
